window.addEventListener("DOMContentLoaded", () => {
    const showActive = (buttons, button) => {
        if (buttons) {
            buttons.forEach(btn => {
                btn.classList.remove("active")
            })
            button.classList.add("active")
        }
    }

    const showBlock = (link, button, block) => {
        if (link) {
            link.addEventListener("click", () => {
                showActive(document.querySelectorAll(".ni-button"), button)
                showActive(document.querySelectorAll(".ni-block"), block)
            })
        }
    }

    const customProductsButton = document.querySelector(
        "button.custom-products"
    )
    const compostableMailersButton = document.querySelector(
        "button.compostable-mailers"
    )
    const bundlesButton = document.querySelector("button.bundles")

    const customProductsBlock = document.querySelector(
        ".ni-block.custom-products"
    )
    const compostableMailersBlock = document.querySelector(
        ".ni-block.compostable-mailers"
    )
    const bundlesBlock = document.querySelector(".ni-block.bundles")

    const niRightArrowCP = document.querySelector(
        ".ni-block.custom-products .ni-right-arrow"
    )

    const niLeftArrowCM = document.querySelector(
        ".ni-block.compostable-mailers .ni-left-arrow"
    )

    const niRightArrowCM = document.querySelector(
        ".ni-block.compostable-mailers .ni-right-arrow"
    )

    const niLeftArrowB = document.querySelector(
        ".ni-block.bundles .ni-left-arrow"
    )

    showBlock(customProductsButton, customProductsButton, customProductsBlock)
    showBlock(niRightArrowCP, compostableMailersButton, compostableMailersBlock)
    showBlock(niLeftArrowCM, customProductsButton, customProductsBlock)
    showBlock(niRightArrowCM, bundlesButton, bundlesBlock)
    showBlock(niLeftArrowB, compostableMailersButton, compostableMailersBlock)

    showBlock(
        compostableMailersButton,
        compostableMailersButton,
        compostableMailersBlock
    )
    showBlock(bundlesButton, bundlesButton, bundlesBlock)

    const getStarted = document.querySelector(".get-started")
    const myAccount = document.querySelector(".my-account")

    if (myAccount) {
        myAccount.addEventListener("click", e => {
            e.preventDefault()

            const dropdown = document.querySelector(".ni-nav-dropdown")
            const menu = document.querySelector(".menu")
            const overlay = document.querySelector(".ni-overlay")

            getStarted.classList.remove("active")
            menu.classList.remove("active")
            overlay.classList.remove("active")

            dropdown.classList.toggle("active")
            myAccount.classList.toggle("active")
        })
    }

    if (getStarted) {
        getStarted.addEventListener("click", e => {
            e.preventDefault()

            const menu = document.querySelector(".menu")
            const dropdown = document.querySelector(".ni-nav-dropdown")
            const overlay = document.querySelector(".ni-overlay")

            overlay.classList.toggle("active")
            dropdown.classList.remove("active")
            myAccount.classList.remove("active")

            getStarted.classList.toggle("active")
            menu.classList.toggle("active")
        })
    }

    const niMenu = document.querySelector(".ni-menu")

    const niClose = document.querySelector(".ni-close")

    if (niClose) {
        niClose.addEventListener("click", () => {
            const niMobileMenu = document.querySelector(".ni-mobile-menu")
            const niCartLink = document.querySelector(".ni-cart-link")
            const menu = document.querySelector(".menu")

            niMobileMenu.classList.remove("active")
            menu.classList.remove("active")

            niClose.classList.remove("active")
            niMenu.classList.remove("open")
            niMenu.classList.remove("back")
            niCartLink.classList.add("active")
        })
    }

    if (niMenu) {
        niMenu.addEventListener("click", () => {
            const niMobileMenu = document.querySelector(".ni-mobile-menu")
            const niCartLink = document.querySelector(".ni-cart-link")
            const menu = document.querySelector(".menu")

            if (niMenu.classList.contains("back")) {
                niMenu.classList.add("open")
                niMobileMenu.classList.add("active")
                menu.classList.remove("active")
                niMenu.classList.remove("back")
                niCartLink.classList.remove("active")
                niClose.classList.add("active")
            } else {
                niMenu.classList.toggle("open")
                niMobileMenu.classList.toggle("active")
                niCartLink.classList.toggle("active")
                niClose.classList.toggle("active")
            }
        })
    }

    const getStartedLink = document.querySelector(".get-started-link")

    if (getStartedLink) {
        getStartedLink.addEventListener("click", () => {
            const niMobileMenu = document.querySelector(".ni-mobile-menu")
            const menu = document.querySelector(".menu")

            niMenu.classList.add("back")
            niMobileMenu.classList.remove("active")
            menu.classList.add("active")
        })
    }
})
